import React, { Component } from "react";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore
} from "react-toasts";
import { callApi } from "../../utils/api";
import BankForm from "./BankForm";
import DSAForm from "./DSAForm";
import PropertyOwnerForm from "./PropertyOwnerForm";
import UploadDocument from "./uploadDocument";
import { cloneDeep } from "lodash";
import Axios from "axios";
import moment from "moment";
import Select from "react-select";
import { notifyToUser } from "../../utils/firebase";
import { pushnotificationApi } from "../../utils/pushNotify";
import { ADMIN_ROLE, MANAGER_ROLE } from "../../utils/role";
import { stat } from "fs";
import { log } from "console";
import { RouteComponentProps } from "react-router-dom";
import { title } from "process";
import BackButtonWithConfirmation from "../../utils/BackButtonWithConfirmation";
import { getExtentUnits } from "../../utils/staticData";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import { hasPageAccess } from "../../utils/pagePermissionService";
import { defaultLoginBillingState, stripLoginBillingServiceChargesFromPayload, validateLoginBillingFields } from "../../utils/loginBillingUtils";

declare var $: any;
interface AllProps {
  match: any;
  history: any;
  location: any;
}

interface Title {
  isValid: boolean;
  doc_no: string;
  doc_type: string;
  name: string;
  schedule: string;
  survey_no_extent: {
    extent: string;
    survey_no: string;
    sur_extent_unit: string;
  }[];
}
interface PrivatelistItem {
  id: string;
  name: string;
  mobile: string;
  email: string;
  id_key: string;
}
class AddFile extends Component<AllProps> {
  documentFormat = {
    base: "",
    base_url: "",
    doc_path: "",
    docNoYear: "",
    particular: "xerox",
    type: "",
    details: {},
    fileNames: [],
    isSavedFile: false,
    isValid: true,
    doc_type: "",
    isPdfCompress: 'off',
  };
  firstdocumenttitledeed = {
    base: "",
    base_url: "",
    doc_path: "",
    docNoYear: "",
    particular: "xerox",
    type: "title_deed",
    details: {},
    fileNames: [],
    isSavedFile: false,
    isValid: true,
    doc_type: "",
    isPdfCompress: 'off',
  };
  firstdocumentsaleagree = {
    base: "",
    base_url: "",
    doc_path: "",
    docNoYear: "",
    particular: "xerox",
    type: "sale_agreement",
    details: {},
    fileNames: [],
    isSavedFile: false,
    isValid: true,
    doc_type: "",
    isPdfCompress: 'off',
  };
  state = {
    bankName: "",
    lawhandsBranches: [] as any,
    bankid: '',
    bank_private: "",
    name: "",
    file_id: "",
    base: [],
    borrower_name: "",
    contact_number: "",
    loan_amount: "",
    app_id: "",
    redirect: false,
    manage: false,
    isNext: false,
    isLoading: false,
    doctype: "",
    doctypes: [],
    docToPreview: "",
    isNewFile: false,
    categoriesList: [],
    required: false,
    isbtnload: false,
    products: [],
    filteredProduct: [],
    product_id: "",
    selected_product_id: "",
    lawhands_branch: "",
    branch: "",
    bank_name: "",
    global_search: "",
    deeds: [],
    type: "title_deed",
    opinion_type: "1",
    file_initiation_type: "",
    // titlelist: [],
    titlelist: [] as Title[],
    privateList: [] as PrivatelistItem[],
    userHintAboutFile: "",
    outreason: "",
    selectVal: false,
    file_idfk: this.props.match.params.id,
    extentUnits: [],
    edit_global: false,
    edit_reason: [] as string[],
    coApplicant: "",
    propertyAddress: "",
    isGlobalPdfCompress: '',
    globalPdfCompressQuality: '',
    isFrontOfficePdfCompressShow: '',
    isSroEcPdfCompressQuality: '',
    isOnlineEcPdfCompressQuality: '',
    mailSubject: '',
    isFetchingEmails: false,
    isMailSubjectFetched: false,
    showMailSelectionModal: false,
    mailSelectionCandidates: [] as any[],
    selectedMailCandidateKey: "",
    selectedMailThreadId: null as number | null,
    isSelectingMail: false,
    delete_items: {},
    ...defaultLoginBillingState,
  };
  async componentDidMount() {
    if (Number(this.props.match.params.id) == 0 && !localStorage.getItem("booleanloginfile") && !localStorage.getItem("LoginFile")) {
      // user came back manually
      this.props.history.replace("/pending-file");
    }
    this.fetchPdfSettings();
    this.listBankproduct();
    this.getDocTypes();
    this.getCategories();
    this.getLawHandsBranches();
    this.getOutTime();
    const extentUnits = getExtentUnits();
    this.setState({ extentUnits });
    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) {
      this.ouTime();
    }
    const isNewFile = Number(this.props.match.params.id) === 0;
    console.log("isNewFile", isNewFile);
    if (!isNewFile) {
      setTimeout(() => {
        this.getFileDetail();
      }, 1000);
    }
    this.setState({ isNewFile });
    const globalSearchValue = localStorage.getItem('global_search');
    const editglobalSearchValue = localStorage.getItem('edit_global_search');
    const booleanEditGlobalSearchValue = editglobalSearchValue === 'true';
    const booleanGlobalSearchValue = globalSearchValue === 'true';
    this.setState({ global_search: booleanGlobalSearchValue, edit_global: booleanEditGlobalSearchValue })
    this.getDeeds();
  }
  fetchPdfSettings = () => {
    callApi("POST", "pdf_category.php")
      .then((res) => res.data)
      .then((response: any) => {
        if (response.result && response.data) {
          const isGlobalPdfCompress = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.status == '1';
          const globalPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.quality;
          const isFrontOfficePdfCompressShow = response.data['Pdf document']?.find((item: any) => item.name == 'In Front Office Show/Hide')?.status == '1';
          const isSroEcPdfCompressQuality = response.data['Pdf Category']?.find((item: any) => item.name == 'SRO Encumbrance Certificate')?.quality;
          const isOnlineEcPdfCompressQuality = response.data['Pdf Category']?.find((item: any) => item.name == 'Online Encumbrance Certificate')?.quality;
          this.setState({
            isGlobalPdfCompress,
            isFrontOfficePdfCompressShow,
            globalPdfCompressQuality,
            isSroEcPdfCompressQuality,
            isOnlineEcPdfCompressQuality
          });
        }
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Failed to load PDF settings");
      });
  };
  getDeeds = () => {
    callApi("POST", "deed_master_get.php", { category: this.state.type })
      .then(res => res.data)
      .then(response => {
        if (response.data && response.data.length) {
          const deeds = response.data;
          this.setState({ deeds });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      window.location.reload();
    }
  }
  componentWillUnmount() {
    localStorage.setItem('global_search', JSON.stringify(false));
    localStorage.setItem('edit_global_search', JSON.stringify(false));
    localStorage.removeItem("booleanloginfile");
    localStorage.removeItem("LoginFile");
  }
  listBankproduct = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "bank_product_get.php")
      .then(res => res.data)
      .then(response => {
        const files = response.data;
        this.setState({ products: files });
      })
      .catch(err => {
        console.log(err);
      });
  };
  previousPop = () => {
    $("#out_reason").modal("show");
    $("#another-reason").modal("hide");
  }
  BacktoFile = () => {
    $("#out_reason").modal("hide");
    const fileid1: any = localStorage.getItem("currentfileId");

    this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
  }
  getOutTime = () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime))
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
    else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }

  }
  ouTime = () => {
    const getfileId: any = localStorage.getItem("currentfileId");
    if (localStorage.getItem("currentfileId")) {
      $("#out_reason").modal("show");
    }
  }
  outimeGet = () => {
    this.setState({ isLoading: true });
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    const outtime: any = localStorage.getItem("outtimeGet");
    const outdate: any = localStorage.getItem("OutDateGet");
    const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
    const insertId: any = localStorage.getItem("ProcessEodInsertID");
    if (this.state.outreason == "") {
      this.setState({ selectVal: true });
    }
    else {
      let obj = {
        "file_id": JSON.parse(fileid1),
        "user_id": JSON.parse(userid1),
        "in_reason": JSON.parse(inreason),
        "out_reason": this.state.outreason,
        "intime": JSON.parse(intime),
        "outtime": JSON.parse(outtime),
        "insert_date": JSON.parse(outdate),
        "total_seconds": secondsSpent,
        "insert_id": insertId
      }
      callApi("POST", "process_eod_insert.php", obj)
        .then(res => res.data)
        .then(response => {
          this.setState({ isLoading: false });
          // localStorage.removeItem("currentfileId");
          localStorage.removeItem("in_reason");
          localStorage.removeItem("outreason");
          localStorage.removeItem("IntimeGet");
          localStorage.removeItem("OutDateGet");
          $("#out_reason").modal("hide");
          $("#another-reason").modal("hide");
          ToastsStore.success("Your Reason Saved Successfully");
          let process_officerId: any = localStorage.getItem("process_office_id");
          let process_officer_id = JSON.parse(process_officerId);
          const userid1: any = localStorage.getItem("user1");
          let user_id = JSON.parse(userid1);
          const take_file: any = localStorage.getItem("takenfile_id");
          const user: any = localStorage.getItem("user");
          const getfileId: any = localStorage.getItem("currentfileId");
          if (process_officer_id == user_id && take_file != "" && take_file == getfileId) {
            this.fileout(fileid1);
          } else {
            localStorage.removeItem('currentfileId');
          }
        }).catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
          ToastsStore.error("Your Reason Not Stored");
        })
    }
  }
  fileout = (fileid1) => {
    let fileId = JSON.parse(fileid1);
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      id: fileId,
      reason: "File Out",
      created_by: JSON.parse(loginuser)
    }
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {
        localStorage.removeItem('currentfileId');
        // localStorage.removeItem("takenfile_id");
      });
  }
  onchangeReason = (e: any) => {

    if (e.target.value == "Other") {
      this.setState({ in_reason: "", selectVal: false })
      $("#out_reason").modal("hide");
      $("#another-reason").modal("show");
    }
    else if (e.target.value == "select") {
      this.setState({ setResponse: false })
    }
    else {
      // this.setState({})
      this.setState({ [e.target.name]: e.target.value, selectVal: false });
    }
  };
  onchange = (e: any) => {
    this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
  };
  getCategories = () => {
    callApi("POST", "category.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ categoriesList: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleDocumentDetailsChange = (value, index, key, type) => {
    const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];
    if (key == "docNoYear" && type != "deed") {

      const isValidInput = /^[0-9/-]*$/.test(value);

      if (!isValidInput) {
        // Display an error message or handle the invalid input as needed
        console.error("Invalid input. Please enter only numeric characters, slash, or hyphen.");
        return;
      }
      let baseArray = cloneDeep(this.state.base);
      baseArray[index] = {
        ...baseArray[index],
        [key]: value,
      };
      this.setState({ base: baseArray });
    } else {
      let baseArray = cloneDeep(this.state.base);
      if (key == 'doc_type') {
        if (invalidDocuments.includes(value)) {
          baseArray[index] = {
            ...baseArray[index],
            'docNoYear': '',
          };
          this.setState({ base: baseArray });
        }
      }

      baseArray[index] = {
        ...baseArray[index],
        [key]: value,
      };
      this.setState({ base: baseArray });
    }
  };

  handleDocumentFilesChange = (files, index, parentDetails) => {
    const { isGlobalPdfCompress } = this.state;
    const file = files.fileList[0];

    // *** If not a PDF → Direct Upload ***
    if (!file?.type?.includes("pdf")) {
      return this.s3upload(files, index, parentDetails, null);
    }

    // *** If compression disabled → Direct Upload ***
    if (!isGlobalPdfCompress || parentDetails.isPdfCompress != 'on') {
      return this.s3upload(files, index, parentDetails, null);
    }

    // *** If already compressed (avoid double compression) ***
    if (file.alreadyCompressed) {
      return this.s3upload(files, index, parentDetails, null);
    }

    // *** Else compress then upload ***
    this.compressAndUpload(files, index, parentDetails);
  };

  compressAndUpload = async (files, index, parentDetails) => {
    const { deeds, globalPdfCompressQuality, isSroEcPdfCompressQuality, isOnlineEcPdfCompressQuality }: any = this.state;
    this.setState({ isbtnload: true });

    try {
      const file = files.fileList[0];
      const docType = parentDetails.doc_type;

      // Select Compression Quality
      let quality =
        docType === 'SRO Encumbrance Certificate'
          ? isSroEcPdfCompressQuality || globalPdfCompressQuality
          : docType === 'Online Encumbrance Certificate'
            ? isOnlineEcPdfCompressQuality || globalPdfCompressQuality
            : (deeds?.find((d: any) => d.id === parentDetails.doc_type)?.quality || globalPdfCompressQuality);

      const compressResponse = await compressPdf({
        base64: files.base64,
        quality,
      });

      // Flag file as compressed so it won't repeat
      file.alreadyCompressed = true;

      const uploadObj = {
        ...files,
        base64: compressResponse.compressedBase64,
      };

      this.s3upload(uploadObj, index, parentDetails, compressResponse);
    } catch (err) {
      ToastsStore.error("Failed to compress PDF");
      console.error(err);
      this.setState({ isbtnload: false });
    }
  };

  s3upload = (files, index, parentDetails, compressResponse) => {
    let baseArray = cloneDeep(this.state.base);
    const fileSize = [...files.fileList].reduce((a, b) => +a + +b.size, 0);
    if (Number(fileSize) > 26214400) {
      ToastsStore.error("File(s) size shouldn't exceed 25 MB");
    } else {
      this.setState({ isbtnload: true });

      callApi("POST", "s3_upload.php", {
        id: Number(this.props.match.params.id),
        rowId: parentDetails.id,
        base: files.base64,
      })
        .then((res) => {
          if (res.data && res.data.file) {
            baseArray[index] = {
              ...baseArray[index],
              base: res.data.file_name,
              base_url: res.data.url,
              doc_path: files.base64,
              loc_doc_name: files.fileList[0].name,
              originalSize: compressResponse?.originalSize || '',
              compressedSize: compressResponse?.compressedSize || '',
            };
            this.setState({ base: baseArray });
            this.setState({ isbtnload: false });
          } else {
            ToastsStore.error("Failed to upload file(s)");
          }
        })
        .catch((err) => {
          ToastsStore.error("Failed to upload file(s)");
        });
    }
  }
  addUploadDocument = () => {
    if (!["10", "3", "8"].includes(this.state.doctype)) {
      if (this.state.base && this.state.base.length > 0) {
        let baseArray = cloneDeep(this.state.base);
        baseArray.push(this.documentFormat);
        this.setState({ base: baseArray });
      } else {
        let baseArray = cloneDeep(this.state.base);
        baseArray.push(this.firstdocumenttitledeed);
        this.setState({ base: baseArray });
      }
    } else {
      if (this.state.base && this.state.base.length > 0) {
        let baseArray = cloneDeep(this.state.base);

        if (this.state.base.length === 1) {
          baseArray.push(this.firstdocumenttitledeed);
        } else {
          baseArray.push(this.documentFormat);
        }

        this.setState({ base: baseArray });
      } else {
        let baseArray = cloneDeep(this.state.base);
        baseArray.push(this.firstdocumentsaleagree);
        this.setState({ base: baseArray });
      }
    }


  };
  deleteDocumentDetails = (index) => {
    const baseArray = cloneDeep(this.state.base);
    const removedItem = baseArray[index];
    const delete_items: any = { ...(this.state.delete_items || {}) };
    delete_items.baselist = delete_items.baselist || [];
    if (removedItem && removedItem.id) {
      delete_items.baselist.push(removedItem.id);
    }
    baseArray.splice(index, 1);
    this.setState({ base: baseArray, delete_items });
  };
  deleteFile = (index) => {
    const baseArray = cloneDeep(this.state.base);
    baseArray[index] = {
      ...baseArray[index],
      details: {},
      base: "",
      alreadyCompressed: false
    };
    this.setState({ base: baseArray });
  };
  getFileDetail = () => {
    callApi("POST", "front_office_get.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.length &&
          response.data[0].arr &&
          response.data[0].arr.length
        ) {
          const state = response.data[0].arr[0];
          const mail_attachments = response.data[0].mail_attachments;
          const fileStatus = state.file_status;
          state.contact_number = response.data[0].contact_number;
          state.loan_amount = response.data[0].loan_amount;

          // existing base (from DB)
          state.base = response.data[0].base
            ? response.data[0].base.map((base) => {
              return {
                ...base,
                isSavedFile: true,
                // Set default to 'off' if not present
                isPdfCompress: base.isPdfCompress || 'off',
              };
            })
            : [];

          // ✅ PUSH mail attachments ONLY if file_status = -1
          if (fileStatus == "-1" && Array.isArray(mail_attachments) && mail_attachments.length > 0) {
            const attachmentBase = mail_attachments.map((att) => ({
              id: null,
              base: att.filename,
              base_url: att.file_path,
              doc_path: att.file_path,
              loc_doc_name: att.original_filename,
              doc_type: "",          // optional (can map if needed)
              type: "",              // optional
              particular: "original",
              attachmentSource: "mail",
              mail_attachment_id: att?.id,
              isSavedFile: false,
              isPdfCompress: "off",
              originalSize: "",
              compressedSize: "",
            }));

            // 🔥 merge with existing base
            state.base = [...state.base, ...attachmentBase];
          }

          console.log("Fetched File Details base: ", state.base);
          this.filterProduct(response.data[0].arr[0].bank_name);
          if (state.bank_private === "Bank") {
            state.privateList = response.data[0].Dsa;
            state.brolist = response.data[0].brolist;
            state.titlelist = response.data[0].titlelist;
          } else if (state.bank_private === "DSA") {
            state.dsalist = response.data[0].Dsa;
          } else if (state.bank_private === "Private") {
            state.privateList = response.data[0].Dsa;
          }
          state.delete_items = state.delete_items || {};
          state.delete_items.baselist = state.delete_items.baselist || [];
          this.setState({ ...state });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  filterProduct = bankid => {
    if (bankid) {
      const filteredProduct = this.state.products.filter(
        (branch: any) => branch.bank_id === bankid
      );
      const state = this.state;
      state.filteredProduct = filteredProduct;
      this.setState({ ...state });
    } else {
      this.setState({ product_id: "" });
    }
  };
  getDocTypes = () => {
    callApi("GET", "type.php")
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data && response.data.length) {
          this.setState({ doctypes: response.data });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  navigateToDocs = (state: any) => {
    this.setState({ ...state, ...state });
    this.setState({ bankid: state.bank_name })
  };
  formatBytes = (a, b = 2) => {
    if (0 === a) {
      return "0 Bytes";
    }
    const c = 0 > b ? 0 : b,
      d = Math.floor(Math.log(a) / Math.log(1024));
    return (
      parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
      " " +
      ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
    );
  };
  handleFiles = (files: any, type: string, upload) => {
    let base: any = this.state.base ? this.state.base : [];
    if (Number(this.props.match.params.id)) {
      base = [];
    }
    const fileSize = [...files.fileList].reduce((a, b) => +a + +b.size, 0);
    if (Number(fileSize) > 26214400) {
      ToastsStore.error("File(s) size shouldn't exceed 25 MB");
    } else {
      if (upload === "multi") {
        files.base64.map((file: any, index: number) => {
          base.push({ base: file, details: files.fileList[index], type });
        });
      } else {
        base.push({ base: files.base64, details: files.fileList[0], type });
      }
      this.setState({ redirect: true });
      if (Number(this.props.match.params.id)) {
        this.setState({ isLoading: true });
        callApi("POST", "file_upload.php", {
          id: Number(this.props.match.params.id),
          base,
        })
          .then((res) => {
            this.setState({ isLoading: false });
            this.getFileDetail();
            ToastsStore.success("File(s) Uploaded Successully");
          })
          .catch((err) => {
            this.setState({ isLoading: false });
            ToastsStore.error("Failed to upload file(s)");
          });
      }
    }
  };
  deleteDoc = (modal, index) => {
    const base = this.state.base;
    base.splice(index, 1);
    this.setState({ base });
  };
  previewDoc = (url) => {
    this.setState({ docToPreview: url });
  };
  onchangetype(e: any, id: any) {
    this.setState({ [e.target.name]: e.target.value });
  }

  clearBaseAndUploadDocument = () => {
    this.setState(
      { base: [] }, // Clear the existing base
      () => {
        this.addUploadDocument(); // Perform the next action
      }
    );
  };

  handleChange = (e: any) => {
    const clearbase = [1, 2, 4, 5, 6, 7, 8, 9, 11]
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (this.state.bank_private && this.state.doctype && this.state.base.length == 0 && this.state.file_idfk == 0) {
        this.addUploadDocument()
      } else if (this.state.bank_private && (this.state.doctype == "10" || this.state.doctype == "3") && this.state.file_idfk == 0) {
        this.clearBaseAndUploadDocument()

      } else if (this.state.bank_private && (clearbase.includes(Number(this.state.doctype))) && this.state.file_idfk == 0) {
        this.clearBaseAndUploadDocument()
      }
    });
  };
  validateRequiredDocumentsForMailCase = () => {
    const { base, doctype } = this.state;

    // If no documents at all, validation fails
    if (!base || base.length === 0) {
      ToastsStore.error("At least one document is required");
      return false;
    }

    // Check if this is a purchase case (doctype 10, 3, or 8)
    const isPurchaseCase = ["10", "3", "8"].includes(doctype);

    if (isPurchaseCase) {
      // Need at least one sale agreement WITH uploaded file AND one title deed WITH uploaded file
      const hasSaleAgreementWithFile = base.some((doc: any) =>
        doc.type === "sale_agreement" && doc.base && doc.base !== ""
      );
      const hasTitleDeedWithFile = base.some((doc: any) =>
        doc.type === "title_deed" && doc.base && doc.base !== ""
      );

      if (!hasSaleAgreementWithFile || !hasTitleDeedWithFile) {
        ToastsStore.error("Purchase cases require at least one Sale Agreement and one Title Deed with uploaded files");
        return false;
      }
    } else {
      // Non-purchase cases need at least one title deed WITH uploaded file
      const hasTitleDeedWithFile = base.some((doc: any) =>
        doc.type === "title_deed" && doc.base && doc.base !== ""
      );

      if (!hasTitleDeedWithFile) {
        ToastsStore.error("At least one Title Deed with uploaded file is required");
        return false;
      }
    }

    // Optional: Check if ALL documents in the base array have uploaded files
    // Uncomment this if you want to ensure EVERY document row has a file uploaded

    const allDocumentsHaveFiles = base.every((doc: any) => doc.base && doc.base !== "");
    if (!allDocumentsHaveFiles) {
      ToastsStore.error("All document entries must have files uploaded");
      return false;
    }


    return true;
  };

  validateRequiredFileds = (e, status) => {
    this.setState({ required: true });
    const state: any = this.state;

    // uploaddocument validation checking statement
    let isValid;

    if (this.state.isNewFile && this.state.file_initiation_type === "Mail") {
      isValid = true; // New mail files don't need document validation
    } else if (this.state.isNewFile) {
      isValid = this.newvalidateDocuments();
      console.log("new File");
    } else {
      console.log("login File");
      isValid = this.validateDocuments();
    }

    // ✅ ENHANCED: Special validation for existing mail files
    if (!this.state.isNewFile && this.state.file_initiation_type === "Mail") {
      const mailDocsValid = this.validateRequiredDocumentsForMailCase();
      if (!mailDocsValid) {
        return; // Stop if mail document requirements aren't met
      }
      // If mail docs are valid, we still need to ensure the regular validation passes
      isValid = isValid && mailDocsValid;
    }

    //title info validation checking statement
    let isTitleValid;
    if (this.state.titlelist && this.state.titlelist.length > 0) {
      isTitleValid = this.validateTitleList();
    }

    const { titlelist, privateList } = this.state;
    // Update privatelist with names from titlelist
    for (let i = 0; i < titlelist.length; i++) {
      if (i < privateList.length) {
        privateList[i].name = titlelist[i].name;
      } else {
        privateList.push({
          "name": titlelist[i].name,
          "mobile": "",
          "email": "",
          "id": "",
          "id_key": ""
        });
      }
    }
    this.setState({ privateList })

    if (isTitleValid && isValid && state.borrower_name !== "" && state.doctype !== "" && state.bank_name !== "" && state.product_id !== "" && state.branch !== "" && state.lawhands_branch !== "" && state.contact_number !== "" && state.loan_amount !== "" && state.app_id !== "" && state.propertyAddress !== "") {
      const billingError = validateLoginBillingFields(state);
      if (billingError) {
        ToastsStore.error(billingError);
        return;
      }
      if (!Number(this.props.match.params.id)) {
        const emails = state.bank_private === "Bank" ? (state.brolist || []) : state.bank_private === "Private" ? (state.privateList || []) : state.bank_private === "DSA" ? [{ email: state.email }, ...(state.dsalist || [])] : null;
        if (emails && !emails.some((item) => item && String(item.email || "").trim())) {
          ToastsStore.error("Please enter at least one email ID.");
          return;
        }
      }
      this.saveFile(e, status);
    } else {
      ToastsStore.error("Please fill all the required fields");
      return;
    }
  };

  // validateRequiredFileds = (e, status) => {
  //   this.setState({ required: true });
  //   const state: any = this.state;

  //   // uploaddocument validation checking statement
  //   let isValid;

  //   if (this.state.isNewFile && this.state.file_initiation_type === "Mail") {
  //     isValid = true; // New mail files don't need document validation
  //   } else if (this.state.isNewFile) {
  //     isValid = this.newvalidateDocuments();
  //     console.log("new File");
  //   } else {
  //     console.log("login File");
  //     isValid = this.validateDocuments();
  //   }

  //   // ✅ ADD THIS: Special validation for existing mail files
  //   if (!this.state.isNewFile && this.state.file_initiation_type === "Mail") {
  //     const mailDocsValid = this.validateRequiredDocumentsForMailCase();
  //     if (!mailDocsValid) {
  //       return; // Stop if mail document requirements aren't met
  //     }
  //     // If mail docs are valid, we still need to ensure the regular validation passes
  //     isValid = isValid && mailDocsValid;
  //   }

  //   //title info validation checking statement
  //   let isTitleValid;
  //   if (this.state.titlelist && this.state.titlelist.length > 0) {
  //     isTitleValid = this.validateTitleList();
  //   }

  //   const { titlelist, privateList } = this.state;
  //   // Update privatelist with names from titlelist
  //   for (let i = 0; i < titlelist.length; i++) {
  //     if (i < privateList.length) {
  //       privateList[i].name = titlelist[i].name;
  //     } else {
  //       privateList.push({
  //         "name": titlelist[i].name,
  //         "mobile": "",
  //         "email": "",
  //         "id": "",
  //         "id_key": ""
  //       });
  //     }
  //   }
  //   this.setState({ privateList })

  //   if (isTitleValid && isValid && state.borrower_name !== "" && state.doctype !== "" && state.bank_name !== "" && state.product_id !== "" && state.branch !== "" && state.lawhands_branch !== "" && state.contact_number !== "" && state.loan_amount !== "" && state.app_id !== "" && state.propertyAddress !== "") {
  //     this.saveFile(e, status);
  //   } else {
  //     ToastsStore.error("Please fill all the required fields");
  //     return;
  //   }
  // };
  validateTitleList = () => {
    const titleList = this.state.titlelist;
    let isValid = true;
    for (let i = 0; i < titleList.length; i++) {
      const title = titleList[i];
      if (
        !title.doc_no ||
        !title.doc_type ||
        !title.name ||
        !title.schedule ||
        !this.validateSurveyNoExtent(title)
      ) {
        isValid = false;
        if (title) {
          title.isValid = false;
        }
      } else {
        if (title) {
          title.isValid = true;
        }
      }
    }
    this.setState({ titlelist: titleList });
    return isValid;
  };
  validateSurveyNoExtent = (title) => {
    if (!title.survey_no_extent || title.survey_no_extent.length === 0) {
      return false;
    }
    for (let i = 0; i < title.survey_no_extent.length; i++) {
      const survey = title.survey_no_extent[i];
      if (!survey.extent || !survey.survey_no || !survey.sur_extent_unit) {
        return false;
      }
    }
    return true;
  };

  validateRequiredFieldsForGlobalSearch = (e, status) => {
    this.setState({ required: true });
    const state: any = this.state;

    // ✅ ENHANCED: Document validation for mail files with file upload check
    if (this.state.file_initiation_type === "Mail" && !this.state.isNewFile) {
      const isDocumentValid = this.validateRequiredDocumentsForMailCase();
      if (!isDocumentValid) {
        return; // Stop if mail document requirements aren't met
      }
    }

    const hasEditReason = Array.isArray(state.edit_reason)
      ? state.edit_reason.length > 0
      : !!state.edit_reason;

    if (state.borrower_name !== "" && state.doctype !== "" && state.bank_name !== "" && state.product_id !== "" && state.branch !== "" && state.lawhands_branch !== "" && state.contact_number !== "" && state.loan_amount !== "" && state.app_id !== "" && state.propertyAddress !== "" && hasEditReason) {
      const billingError = validateLoginBillingFields(state);
      if (billingError) {
        ToastsStore.error(billingError);
        return;
      }
      this.saveFile(e, status);
    } else {
      ToastsStore.error("Please fill all the required fields");
      return;
    }
  };

  newvalidateDocuments = () => {
    let base: any = this.state.base;
    let isValid = true;
    const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];

    for (let i = 0; i < base.length; i++) {
      const document = base[i];
      if (invalidDocuments.includes(document.doc_type)) {
        base[i].isValid = true;
      }
      else {
        if (document.type == "deed" || document.type == "mother_doc" || document.type == "title_deed" || document.type == "ec_doc") {
          if (!document.docNoYear || !document.doc_type || !document.type || !document.particular) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        } else if (document.type == "rev_rec_doc" || document.type == "sale_agreement") {
          if (!document.doc_type || !document.type || !document.particular) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        }

        else {
          isValid = false;
          base[i].isValid = false;
        }
      }
    }
    return isValid;
  };

  validateDocuments = () => {
    let base: any = this.state.base;
    let isValid = true;
    const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];
    for (let i = 0; i < base.length; i++) {
      const document = base[i];
      if (invalidDocuments.includes(document.doc_type)) {
        base[i].isValid = true;
      }
      else {
        if (document.type == "deed" || document.type == "mother_doc" || document.type == "title_deed" || document.type == "ec_doc") {
          if (!document.docNoYear || !document.doc_type || !document.type || !document.particular || !document.base) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        } else if (document.type == "rev_rec_doc" || document.type == "sale_agreement") {
          if (!document.doc_type || !document.type || !document.particular || !document.base) {
            isValid = false;
            base[i].isValid = false;
          } else {
            base[i].isValid = true;
          }
        }
        else {
          isValid = false;
          base[i].isValid = false;
        }
      }
    }
    return isValid;
  };

  updatePostData = async (postData, banks, branches) => {
    try {
      const bankName =
        banks &&
        banks.length &&
        banks.filter((value) => value.id === postData.bank_name);
      const bankBranch =
        branches &&
        branches.length &&
        branches.filter((value) => value.id === postData.branch);
      const lawHandsBranchName =
        postData &&
        postData.lawhandsBranches &&
        postData.lawhandsBranches.filter(
          (value) => value.id === postData.lawhands_branch
        );
      const customerMobileNumber =
        postData.brolist && !!postData.brolist.length
          ? postData.brolist[0].mobile
          : null;
      if (
        bankName &&
        bankName.length &&
        bankBranch &&
        bankBranch.length &&
        lawHandsBranchName &&
        lawHandsBranchName.length
      ) {
        const PostData = await Axios.post(
          "http://law.elawhands.com/api/postdata.php",
          {
            action: "insert_filelogin",
            date: moment().format("YYYY-MM-DD"),
            service_from: postData.bank_private,
            branch_id: lawHandsBranchName[0].name.trim(),
            bank_id: `${bankName[0].name + "-" + bankBranch[0].name}`,
            customer_name: `${postData.borrower_name}-${customerMobileNumber ? customerMobileNumber : ""
              }`,
          }
        );
      }
    } catch (err) {
      console.log("Post Data Error -> ", err);
      // ToastsStore.error("");
    }
  };

  saveFile = (e, status) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const state: any = this.state;
    const bankList = state.banks;

    const branchList = state.branches;
    delete state.branches;
    delete state.filteredBranches;
    delete state.required;
    state.id = Number(this.props.match.params.id);
    state.file_status = status;
    const user: any = localStorage.getItem("user");
    const report_to = user ? JSON.parse(user)["report_to"] : "";
    state.userId = user ? JSON.parse(user)["userId"] : "";
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    const loginuser: any = localStorage.getItem("user1");
    if (state.id) {
      let req;
      if (status == 0) {
        req = {
          scaned_time: currenttime,
          scaned_date: currentdate,
          scaned_by: JSON.parse(loginuser),
          id: this.props.match.params.id,
          reason: "Scan Completed",
          created_by: JSON.parse(loginuser),
          color: "#afa5bd"
        }
        callApi("POST", "time_update.php", req)
          .then(res => res.data)
          .then(response => {

          });

        let request = {
          file_id: this.props.match.params.id,
          doc_count: state.base.length
        }
        callApi("POST", "file_time.php", request)
          .then(res => res.data)
          .then(response => {

          });
      }
      callApi("POST", "file_update.php", stripLoginBillingServiceChargesFromPayload(state))
        .then((res) => res.data)
        .then((response) => {
          localStorage.setItem('global_search', JSON.stringify(false));
          if (response.office && !response.file) {
            // const notifyData = {
            //   fileId: this.props.match.params.id,
            //   title: "New File Login",
            //   // bank: "test_bank",
            //   // branch: "test_branch",
            //   notifyType: "message",
            // };
            // notifyToUser("user", { ...notifyData, notifyType: "message" }, [
            //   "147",
            // ]);

            this.props.history.push("/pending-file");
          } else if (response.office && response.file) {
            this.props.history.push("/unassigned-file");
          } else {
            ToastsStore.error("File not updated. Please try again!");
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      bankList.forEach(element => {
        if (element.id == state.bank_name) {
          this.setState({ bankName: element.name })
        }
      });
      callApi("POST", "file_create.php", stripLoginBillingServiceChargesFromPayload(state))
        .then((res) => res.data)
        .then((response) => {
          const fileCreated = response && response.office && response.id;
          if (!fileCreated) {
            ToastsStore.error(
              (response && response.message) ? response.message : "File not created. Please try again!"
            );
            this.setState({ isLoading: false });
            return;
          }
          this.fileLogin(response.id);
          ToastsStore.success("File Created Successfully");
          if (this.state.file_initiation_type === 'Mail') {
            this.linkEmailsToFile(response.id);
          }
          this.updatePostData(state, bankList, branchList);
          // ✅ clear flag before leaving
          localStorage.removeItem("booleanloginfile");
          localStorage.removeItem("LoginFile");
          if (response.office && !response.file) {
            this.props.history.push("/pending-file");
          } else if (response.office && response.file) {
            this.props.history.push("/unassigned-file");
          }
          this.setState({ isLoading: false });

          const user: any = localStorage.getItem("user");
          const userId = user ? JSON.parse(user)["userId"] : "";
          const userName = user ? JSON.parse(user)["firstName"] : "";
          const notifyData = {
            title: `${this.state.bankName} New File Created`, notifyType: "message", updatedAt: moment().format("YYYY-MM-DD HH:mm:ss")
          };
          let user_id = userId;
          pushnotificationApi(notifyData, user_id);
          const branchManger: any = localStorage.getItem("branch_manager");
          const branch_Manager = JSON.parse(branchManger);
          const queryOfficer: any = localStorage.getItem("Query_officer");
          const query_ooficer = JSON.parse(queryOfficer);
          const Scan_officer: any = localStorage.getItem("scan_officer");
          const sacanofficer = JSON.parse(Scan_officer);
          const process_mennager: any = localStorage.getItem("process_manager");
          const processManager = JSON.parse(process_mennager);
          if (Array.isArray(branch_Manager) && branch_Manager.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, branch_Manager);

            const branchManager = branch_Manager.join(",");
            let obj = {
              user_id: branchManager,
              reason: "New File Created",
              ...notifyData
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (Array.isArray(query_ooficer) && query_ooficer.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, query_ooficer);
            const queryOfficer = query_ooficer.join(",");
            let obj = {
              // notification_type:"filecreate",
              user_id: queryOfficer,
              ...notifyData,
              reason: "New File Created"
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (Array.isArray(sacanofficer) && sacanofficer.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, sacanofficer);
            const scanOfficer = sacanofficer.join(",");
            let obj = {
              // notification_type:"filecreate",
              user_id: scanOfficer,
              ...notifyData,
              reason: "New File Created"
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (Array.isArray(processManager) && processManager.length > 0) {
            notifyToUser("user", { ...notifyData, notifyType: "message" }, processManager);
            const pManager = processManager.join(",");
            let obj = {
              // notification_type:"filecreate",
              user_id: pManager,
              ...notifyData,
              reason: "New File Created"
            }
            callApi("POST", "pushnotification.php", obj)
              .then((res) => res.data)
              .then((response) => {
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    }
  };
  linkEmailsToFile = (file_id: any) => {
    const { app_id, mailSubject, selectedMailThreadId } = this.state;

    if (!file_id || !app_id) {
      ToastsStore.error("File ID or App ID missing to link emails");
      return;
    }

    this.setState({ isLinkingEmails: true });

    const req: any = {
      action: "link_emails",
      file_id: file_id,
      app_id: app_id,
      subject: mailSubject,
    };
    if (selectedMailThreadId) {
      req.mail_thread_id = selectedMailThreadId;
    }

    callApi("POST", "fetch_query_received_mail.php", req)
      .then((res) => res.data)
      .then((response: any) => {
        if (response.success) {
          ToastsStore.success(
            response.message || "Emails linked to file successfully"
          );
        } else {
          ToastsStore.error(
            response.message || "Failed to link emails"
          );
        }
      })
      .catch((err) => {
        console.error(err);
        ToastsStore.error("Error while linking emails");
      })
      .finally(() => {
        this.setState({ isLinkingEmails: false });
      });
  };

  fileLogin(id) {
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      login_time: currenttime,
      login_date: currentdate,
      login_by: JSON.parse(loginuser),
      id: id,
      reason: "Login",
      created_by: JSON.parse(loginuser),
      color: "#aa8986"
    }
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {

      });
  }
  getLawHandsBranches() {
    callApi("GET", "get_branch.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ lawhandsBranches: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  }
  render() {
    // if (this.state.redirect) {
    //   if (this.state.manage) {
    //     return <Redirect to={"/Front_office_manage"} />;
    //   }
    // }
    const globalSearchValue = localStorage.getItem('global_search');
    const editGlobalSearchValue = localStorage.getItem('edit_global_search');
    const isEditGlobalSearch = editGlobalSearchValue === "true";

    // const flagFromState = this.props.location?.state?.booleanloginfile === true;
    const flagFromLocal = localStorage.getItem("booleanloginfile") === "true";
    const booleanloginfile = flagFromLocal;
    // need to check after live
    const is_thread_mail_enabled = this.state?.lawhandsBranches && this.state?.lawhandsBranches.find((branch: any) => branch.id === this.state?.lawhands_branch)?.is_thread_mail_enabled;
    const ischeckmail = is_thread_mail_enabled == 1;
    return (
      <div className="pcoded-main-container">
        {/* <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_CENTER}
        /> */}
        {/* {this.state.isLoading && (
          <div className="spin-container">
            <span className="imgLoader" />
          </div>
        )} */}

        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div id="form">
                    <div className="list-group">
                      <div className="list-group-item py-3" data-acc-step>
                        <h5 className="mb-0" data-acc-title>
                          Front Office
                        </h5>
                        <div data-acc-content>
                          <form className="my-3" method="POST">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Bank or Private</label>
                                  <select
                                    className="custom-select"
                                    name="bank_private"
                                    value={this.state.bank_private}
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="">Select the Option</option>
                                    <option value="Bank">Bank</option>
                                    <option value="DSA">DSA</option>
                                    <option value="Private">
                                      Property Owner
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Type of Loan<span style={{ color: "red" }}>*</span><span className="inputEgMsg">Eg. Agri / Takeover / Normal</span></label>
                                  <select
                                    className={this.state.required && this.state.doctype === '' ? 'custom-select form-select is-invalid' : 'form-select custom-select'}
                                    name="doctype"
                                    value={this.state.doctype}
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="">Select type of loan</option>
                                    {this.state.doctypes &&
                                      this.state.doctypes.length > 0 &&
                                      this.state.doctypes.map((opt: any) => {
                                        return (
                                          <option key={opt.id} value={opt.id}>
                                            {opt.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                  <div className="invalid-feedback">*Required Field</div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>File Type<span style={{ color: "red" }}>*</span></label>
                                  <select
                                    className={this.state.required && this.state.opinion_type === '' ? 'custom-select form-select is-invalid' : 'custom-select form-select'}
                                    name="opinion_type"
                                    onChange={this.handleChange}
                                    value={this.state.opinion_type}
                                    required >
                                    <option>Select the File Type</option>
                                    <option value="1">New-Login</option>
                                    <option value="2">Second Opinion</option>
                                    <option value="3">Relegal</option>
                                    <option value="4">Topup</option>
                                    <option value="5">Project / APF</option>
                                    <option value="6">Final Report</option>
                                    <option value="7">Supplementary Opinion</option>
                                    <option value="8">Legal Audit</option>
                                    <option value="9">Download</option>
                                  </select>
                                  <div className="invalid-feedback">*Required Field</div>
                                </div>
                              </div>
                            </div>
                            {this.state.bank_private === "Bank" && (
                              <BankForm
                                initialValue={this.state}
                                navigateToDocs={(e: any) =>
                                  this.navigateToDocs(e)
                                }
                                required={this.state.required}
                                isEditGlobalSearch={isEditGlobalSearch}
                              />
                            )}
                            {this.state.bank_private === "DSA" && (
                              <DSAForm
                                initialValue={this.state}
                                navigateToDocs={(e: any) =>
                                  this.navigateToDocs(e)
                                }
                                required={this.state.required}
                              />
                            )}
                            {this.state.bank_private === "Private" && (
                              <PropertyOwnerForm
                                initialValue={this.state}
                                navigateToDocs={(e: any) =>
                                  this.navigateToDocs(e)
                                }
                                required={this.state.required}
                              />
                            )}
                          </form>
                        </div>
                      </div>
                      {/* Document Upload Section */}
                      <div className="list-group-item py-3" data-acc-step>
                        {(ischeckmail == true ? ((this.state.file_initiation_type === "Hard Copy" || !this.state.isNewFile)) : 1) && !isEditGlobalSearch && (<>
                          {globalSearchValue != "true" && (
                            <h5 className="mb-0" data-acc-title>
                              Document Upload
                            </h5>
                          )}
                        </>)}

                        <div className="mt-4">
                          {(ischeckmail == true ? ((this.state.file_initiation_type === "Hard Copy" || !this.state.isNewFile)) : 1) && globalSearchValue != "true" && !isEditGlobalSearch && this.state.base.length > 0 &&
                            this.state.base.map((document, index) => (
                              <UploadDocument
                                baseDetails={document}
                                handleDocumentDetailsChange={
                                  this.handleDocumentDetailsChange
                                }
                                handleDocumentFilesChange={
                                  this.handleDocumentFilesChange
                                }
                                deleteDocumentDetails={
                                  this.deleteDocumentDetails
                                }
                                deleteFile={this.deleteFile}
                                previewDoc={this.previewDoc}
                                categoriesList={this.state.categoriesList}
                                deedList={this.state.deeds}
                                index={index}
                                newfile={this.state.isNewFile}
                                isbtnload={this.state.isbtnload}
                                doctype={this.state.doctype}
                                bank_private={this.state.bank_private}
                                state={this.state}
                              />
                            ))}

                          {isEditGlobalSearch && (
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Edit Reason<span style={{ color: "red" }}>*</span></label>
                                <Select
                                  isMulti
                                  className={this.state.required && (!this.state.edit_reason || this.state.edit_reason.length === 0) ? 'is-invalid' : ''}
                                  classNamePrefix="react-select"
                                  name="edit_reason"
                                  options={[
                                    { value: "LH Branch, Bank, Product, Bank Branch Changes.", label: "LH Branch, Bank, Product, Bank Branch Changes." },
                                    { value: "Borrower, Co-Borrower Name Changes.", label: "Borrower, Co-Borrower Name Changes." },
                                    { value: "App-Id Changes.", label: "App-Id Changes." },
                                    { value: "Property, Location, Address Changes.", label: "Property, Location, Address Changes." },
                                    { value: "Type of Loan Changes", label: "Type of Loan Changes" },
                                    { value: "Loan Amount Changes", label: "Loan Amount Changes" },
                                    { value: "Download Option Updated", label: "Download Option Updated" },
                                  ]}
                                  value={(this.state.edit_reason || []).map((reason: string) => ({
                                    value: reason,
                                    label: reason
                                  }))}
                                  onChange={(selectedOptions: any) => {
                                    const selectedValues = (selectedOptions || []).map((option: any) => option.value);
                                    this.setState({ edit_reason: selectedValues });
                                  }}
                                  placeholder="Select edit reason"
                                />
                                <div className="invalid-feedback">*Required Field</div>
                              </div>
                            </div>
                          )}


                          {((booleanloginfile === true) || (this.props.match.params.id == 0)) && (
                            <div className="my-3 d-flex justify-content-between align-items-center">
                              {/* Left side: Add Document */}
                              {(ischeckmail == true ? ((this.state.file_initiation_type === "Hard Copy" || !this.state.isNewFile)) : 1) && globalSearchValue != "true" && !isEditGlobalSearch && (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm upload-document-button"
                                    onClick={() => this.addUploadDocument()}
                                    disabled={this.state.bank_private === '' || this.state.doctype === ''}
                                  >
                                    Add Document +
                                  </button>
                                </div>
                              )}

                              {/* Right side: Save & Cancel */}
                              <div className="d-flex align-items-center">
                                {globalSearchValue != "true" && !this.state.isNewFile && !isEditGlobalSearch && (
                                  <button
                                    type="submit"
                                    className="btn btn-success"
                                    onClick={(e) => {
                                      if (editGlobalSearchValue != "true") {
                                        this.validateRequiredFileds(e, 0);
                                      } else {
                                        this.validateRequiredFieldsForGlobalSearch(e, -2);
                                      }
                                    }}
                                    style={{ marginRight: "10px" }}
                                    disabled={this.state.isLoading}
                                  >
                                    {this.state.isLoading && <i className="fa fa-spinner fa-spin"></i>}
                                    Save & Submit
                                  </button>
                                )}

                                <button
                                  type="submit"
                                  className="btn btn-success"
                                  onClick={(e) => {
                                    if (editGlobalSearchValue != "true") {
                                      this.validateRequiredFileds(e, -1);
                                    } else {
                                      this.validateRequiredFieldsForGlobalSearch(e, -2);
                                    }
                                  }}
                                  style={{ marginRight: "10px" }}
                                  disabled={this.state.isLoading}
                                >
                                  {this.state.isLoading && <i className="fa fa-spinner fa-spin"></i>}
                                  Save
                                </button>

                                <BackButtonWithConfirmation
                                  history={this.props.history}
                                  title={"Cancel"}
                                  styles={{
                                    backgroundColor: 'red',
                                    height: "40px",
                                    borderRadius: "5px"
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="preview-document"
          role="dialog"
          aria-hidden={this.state.docToPreview === ""}
          {...(this.state.docToPreview === "" && { inert: "" })}

        >
          <div className="modal-dialog modal-lg" role="document"
            style={{ maxWidth: "1400px" }}
          >
            <div className="modal-content" style={{ height: "90vh" }}>
              <div className="modal-header">
                <h5 className="modal-title">Document Preview</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden={this.state.docToPreview === ""}>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <iframe
                  width="100%"
                  height="100%"
                  src={this.state.docToPreview}
                ></iframe>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({ docToPreview: "" });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* THIS FOR OUT REASON MODAL */}
        <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog ">
            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
              <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
              </div>
              <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                <select
                  className="custom-select"
                  name="outreason"
                  value={this.state.outreason}
                  onChange={(e) => this.onchangeReason(e)}
                  required
                  id="select1"
                  style={{ marginTop: '8px' }}
                >
                  <option value="select">Select Your Reason</option>
                  <option value="Query Raised">Query Raised</option>
                  <option value=" Re-Query Raised"> Re-Query Raised</option>
                  <option value="Hold ">Hold </option>
                  <option value="Completed">Completed</option>
                  <option value="Other">Others</option>

                </select>
                {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
              </div>
              <div className="modal-footer" style={{ marginTop: '27px' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={this.state.isLoading}
                  onClick={this.outimeGet}
                  style={{ width: '76px', fontSize: '17px' }}
                > {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : "OK"}</button>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={this.BacktoFile}
                  style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                > Back To File</button>
              </div>
            </div>
          </div>
        </div>
        {/* OTHER REASON MODAL */}
        <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog ">
            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
              <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
              <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                {/* <div className="col-md-5"> */}
                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                  <textarea
                    className="form-control"
                    placeholder="Type Your Reason"
                    name="outreason" onChange={this.onchange} />
                  {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                </div>
                {/* </div> */}

              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.outimeGet()}
                  style={{ width: '76px', fontSize: '17px' }}
                  disabled={this.state.isLoading}
                > {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : "OK"}</button>
                <button
                  type="button"
                  className="btn btn-outline"

                  onClick={() => this.previousPop()}
                  // onClick={this.disableModalHandler}
                  style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                > Back</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddFile;
